import type { Conversation, Message, CallRecord } from "./types"

export const MOCK_CONVERSATIONS: Conversation[] = [
  {
    id: "1",
    name: "Alex Thompson",
    lastMessage: "Sure, let's catch up tomorrow at 10!",
    time: "10:42 AM",
    isOnline: true,
    unreadCount: 2,
    isSentByMe: false,
    messageStatus: "read",
    imageUrl: "https://randomuser.me/api/portraits/men/32.jpg",
    isPinned: true,
    isFavorite: true,
  },
  {
    id: "2",
    name: "Design Team",
    lastMessage: "Sarah: The new mockups are ready for review",
    time: "9:15 AM",
    isOnline: false,
    unreadCount: 5,
    isSentByMe: false,
    messageStatus: "delivered",
    imageUrl: "https://randomuser.me/api/portraits/women/44.jpg",
    isGroup: true,
    isTyping: true,
    typingUser: "Sarah",
    participants: [
      { id: "p1", name: "Sarah Mitchell", imageUrl: "https://randomuser.me/api/portraits/women/44.jpg", isOnline: true },
      { id: "p2", name: "David Park", imageUrl: "https://randomuser.me/api/portraits/men/55.jpg", isOnline: false },
      { id: "p3", name: "Emma Wilson", imageUrl: "https://randomuser.me/api/portraits/women/68.jpg", isOnline: true },
    ],
  },
  {
    id: "3",
    name: "Priya Sharma",
    lastMessage: "Can you share the Q3 report?",
    time: "Yesterday",
    isOnline: false,
    unreadCount: 0,
    isSentByMe: true,
    messageStatus: "read",
    imageUrl: "https://randomuser.me/api/portraits/women/26.jpg",
  },
  {
    id: "4",
    name: "InMeet Support",
    lastMessage: "Your account has been upgraded to Pro.",
    time: "Yesterday",
    isOnline: true,
    unreadCount: 1,
    isSentByMe: false,
    messageStatus: "read",
    isBot: true,
  },
  {
    id: "5",
    name: "Engineering Guild",
    lastMessage: "You: LGTM, merging now 🚀",
    time: "Mon",
    isOnline: false,
    unreadCount: 0,
    isSentByMe: true,
    messageStatus: "read",
    isGroup: true,
    imageUrl: "https://randomuser.me/api/portraits/men/41.jpg",
    participants: [
      { id: "p4", name: "Ramakrishna", isOnline: true, isAdmin: true },
      { id: "p5", name: "Kiran Bhat", imageUrl: "https://randomuser.me/api/portraits/men/41.jpg", isOnline: false },
    ],
  },
  {
    id: "6",
    name: "Jordan Lee",
    lastMessage: "Missed call",
    time: "Mon",
    isOnline: false,
    unreadCount: 1,
    isSentByMe: false,
    messageStatus: "sent",
    imageUrl: "https://randomuser.me/api/portraits/men/64.jpg",
    isCall: true,
    isMissedCall: true,
    callDir: "in",
  },
  {
    id: "7",
    name: "HR Announcements",
    lastMessage: "Reminder: Annual performance review due Friday",
    time: "Sun",
    isOnline: false,
    unreadCount: 0,
    isSentByMe: false,
    messageStatus: "delivered",
    isGroup: true,
    isMuted: true,
  },
  {
    id: "8",
    name: "Maria Chen",
    lastMessage: "Great presentation today!",
    time: "Sat",
    isOnline: true,
    unreadCount: 0,
    isSentByMe: false,
    messageStatus: "read",
    imageUrl: "https://randomuser.me/api/portraits/women/89.jpg",
    isFavorite: true,
  },
  {
    id: "9",
    name: "Old Project Chat",
    lastMessage: "Thanks for everything!",
    time: "2 weeks ago",
    isOnline: false,
    unreadCount: 0,
    isSentByMe: true,
    messageStatus: "read",
    isArchived: true,
  },
]

export const MOCK_MESSAGES: Record<string, Message[]> = {
  "1": [
    { id: "m1", text: "Hey! How's the new feature coming along?", time: "10:10 AM", isSentByMe: false, status: "read", senderName: "Alex Thompson", senderImageUrl: "https://randomuser.me/api/portraits/men/32.jpg" },
    { id: "m2", text: "Really well! Just fixing a few edge cases. Should be done by EOD.", time: "10:15 AM", isSentByMe: true, status: "read", isStarred: true },
    { id: "m3", text: "Awesome 🚀 The team is excited to see it.", time: "10:18 AM", isSentByMe: false, status: "read", senderName: "Alex Thompson", senderImageUrl: "https://randomuser.me/api/portraits/men/32.jpg", isPinned: true, reactions: [{ emoji: "🚀", count: 2, byMe: true }, { emoji: "❤️", count: 1, byMe: false }] },
    { id: "m4", text: "Shall we do a quick demo call?", time: "10:30 AM", isSentByMe: false, status: "read", senderName: "Alex Thompson", senderImageUrl: "https://randomuser.me/api/portraits/men/32.jpg" },
    { id: "m5", text: "Sure, let's catch up tomorrow at 10!", time: "10:42 AM", isSentByMe: true, status: "delivered", isStarred: true },
    { id: "m6", type: "image", text: "Check out the new UI design!", attachmentUrl: "https://picsum.photos/400/300?random=10", time: "10:44 AM", isSentByMe: false, status: "read", senderName: "Alex Thompson", senderImageUrl: "https://randomuser.me/api/portraits/men/32.jpg", reactions: [{ emoji: "😍", count: 3, byMe: true }] },
    { id: "m7", type: "audio", text: "", audioDuration: 12, time: "10:46 AM", isSentByMe: true, status: "read" },
    { id: "m8", type: "file", text: "", attachmentName: "Q3_Report_2025.pdf", attachmentSize: 2457600, attachmentUrl: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf", time: "10:48 AM", isSentByMe: false, status: "read", senderName: "Alex Thompson", senderImageUrl: "https://randomuser.me/api/portraits/men/32.jpg" },
    { id: "m9", text: "Also check this out for inspiration", time: "10:50 AM", isSentByMe: false, status: "read", senderName: "Alex Thompson", senderImageUrl: "https://randomuser.me/api/portraits/men/32.jpg", linkPreview: { url: "https://inmeet.io", title: "InMeet — Professional Video Meetings", description: "Host seamless meetings, webinars and more with InMeet.", image: "https://picsum.photos/300/150?random=20" } },
    { id: "m10", text: "Looks great! Will review before EOD 👍", time: "10:52 AM", isSentByMe: true, status: "delivered" },
    { id: "m11", type: "video", text: "Quick demo recording", attachmentUrl: "https://www.w3schools.com/html/mov_bbb.mp4", attachmentName: "demo_clip.mp4", attachmentSize: 1048576, time: "10:54 AM", isSentByMe: false, status: "read", senderName: "Alex Thompson", senderImageUrl: "https://randomuser.me/api/portraits/men/32.jpg" },
    { id: "m12", type: "file", text: "", attachmentName: "Project_Brief.pdf", attachmentSize: 524288, attachmentUrl: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf", time: "10:56 AM", isSentByMe: true, status: "delivered" },
    { id: "m13", type: "file", text: "", attachmentName: "Design_Specs.docx", attachmentSize: 2097152, time: "10:57 AM", isSentByMe: false, status: "read", senderName: "Alex Thompson", senderImageUrl: "https://randomuser.me/api/portraits/men/32.jpg" },
    { id: "m14", type: "file", text: "", attachmentName: "Budget_2025.xlsx", attachmentSize: 3145728, time: "10:58 AM", isSentByMe: true, status: "delivered" },
    { id: "m15", type: "location", text: "", time: "11:00 AM", isSentByMe: false, status: "read", senderName: "Alex Thompson", senderImageUrl: "https://randomuser.me/api/portraits/men/32.jpg" },
    { id: "m16", type: "contact", text: "", time: "11:01 AM", isSentByMe: true, status: "delivered" },
    { id: "m17", type: "image", text: "", attachmentUrl: "https://picsum.photos/400/300?random=55", attachmentName: "screenshot.png", attachmentSize: 892416, time: "11:02 AM", isSentByMe: false, status: "read", senderName: "Alex Thompson", senderImageUrl: "https://randomuser.me/api/portraits/men/32.jpg" },
    { id: "m18", isCall: true, isMissedCall: false, isVideoCall: false, callDir: "out", text: "Voice call · 4 min 23 sec", time: "11:05 AM", isSentByMe: true, status: "read" },
    { id: "m19", isCall: true, isMissedCall: true, isVideoCall: false, callDir: "in", text: "Missed voice call", time: "11:10 AM", isSentByMe: false, status: "read", senderName: "Alex Thompson" },
    { id: "m20", isCall: true, isMissedCall: false, isVideoCall: true, callDir: "in", text: "Video call · 12 min 08 sec", time: "11:15 AM", isSentByMe: false, status: "read", senderName: "Alex Thompson" },
    { id: "m21", isCall: true, isMissedCall: true, isVideoCall: true, callDir: "in", text: "Missed video call", time: "11:18 AM", isSentByMe: false, status: "read", senderName: "Alex Thompson" },
    { id: "m22", text: "All types shown above — text, image, video, audio, PDF, DOCX, XLSX, location, contact, calls ✓", time: "11:20 AM", isSentByMe: true, status: "delivered" },
  ],
  "2": [
    { id: "m1", text: "Everyone please review the design before the sync", time: "8:00 AM", isSentByMe: false, status: "read", senderName: "David Park", senderImageUrl: "https://randomuser.me/api/portraits/men/55.jpg" },
    { id: "m2", text: "On it! Will send feedback by noon.", time: "8:30 AM", isSentByMe: true, status: "read" },
    { id: "m3", type: "image", text: "The new mockups are ready for review", attachmentUrl: "https://picsum.photos/400/280?random=11", time: "9:15 AM", isSentByMe: false, status: "delivered", senderName: "Sarah Mitchell", senderImageUrl: "https://randomuser.me/api/portraits/women/44.jpg", reactions: [{ emoji: "👍", count: 4, byMe: true }, { emoji: "🔥", count: 2, byMe: false }] },
    { id: "m4", type: "file", text: "", attachmentName: "Design_System_v2.fig", attachmentSize: 8192000, time: "9:18 AM", isSentByMe: false, status: "delivered", senderName: "Sarah Mitchell", senderImageUrl: "https://randomuser.me/api/portraits/women/44.jpg" },
  ],
  "3": [
    { id: "m1", text: "Hi Priya! How are you?", time: "Yesterday 3:00 PM", isSentByMe: true, status: "read" },
    { id: "m2", text: "Doing great, thanks! Did you see the meeting notes?", time: "Yesterday 3:05 PM", isSentByMe: false, status: "read", senderName: "Priya Sharma", senderImageUrl: "https://randomuser.me/api/portraits/women/26.jpg" },
    { id: "m3", text: "Can you share the Q3 report?", time: "Yesterday 3:10 PM", isSentByMe: true, status: "read" },
  ],
}

export const MOCK_CALLS: CallRecord[] = [
  { id: "c1", name: "Alex Thompson", imageUrl: "https://randomuser.me/api/portraits/men/32.jpg", isVideoCall: false, isMissedCall: false, callDir: "out", time: "Today, 10:05 AM", duration: "12 min", isOnline: true },
  { id: "c2", name: "Jordan Lee", imageUrl: "https://randomuser.me/api/portraits/men/64.jpg", isVideoCall: false, isMissedCall: true, callDir: "in", time: "Today, 9:40 AM", isOnline: false },
  { id: "c3", name: "Priya Sharma", imageUrl: "https://randomuser.me/api/portraits/women/26.jpg", isVideoCall: true, isMissedCall: false, callDir: "in", time: "Yesterday, 4:30 PM", duration: "28 min", isOnline: false },
  { id: "c4", name: "Maria Chen", imageUrl: "https://randomuser.me/api/portraits/women/89.jpg", isVideoCall: true, isMissedCall: false, callDir: "out", time: "Yesterday, 2:00 PM", duration: "5 min", isOnline: true },
  { id: "c5", name: "Alex Thompson", imageUrl: "https://randomuser.me/api/portraits/men/32.jpg", isVideoCall: false, isMissedCall: true, callDir: "in", time: "Mon, 11:20 AM", isOnline: true },
  { id: "c6", name: "Design Team", isVideoCall: true, isMissedCall: false, callDir: "out", time: "Mon, 9:00 AM", duration: "45 min", isOnline: false },
]

